import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { fontSize, gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import { actionSectionDesktopCSS, actionSectionMobileCSS, skeletonCSS } from '../../common/styles';
var gridSize = gridSizeFn();
var searchCommonCSS = {
  borderRadius: 6,
  boxSizing: 'border-box',
  height: "".concat(gridSize * 4, "px"),
  padding: "0 ".concat(gridSize, "px 0 40px"),
  width: '220px'
};
export var searchIconCSS = actionSectionMobileCSS;
export var searchIconSkeletonCSS = searchIconCSS;
export var searchInputContainerCSS = _objectSpread({
  marginLeft: '20px',
  marginRight: "".concat(gridSize, "px"),
  position: 'relative'
}, actionSectionDesktopCSS);
export var searchInputCSS = function searchInputCSS(_ref) {
  var search = _ref.mode.search;
  return _objectSpread(_objectSpread(_objectSpread({}, searchCommonCSS), {}, {
    border: '2px solid',
    fontSize: "".concat(fontSize(), "px"),
    outline: 'none',
    '::placeholder': {
      color: 'inherit'
    }
  }, search.default), {}, {
    ':focus': search.focus
  });
};
export var searchInputIconCSS = {
  height: '20px',
  left: '10px',
  position: 'absolute',
  pointerEvents: 'none',
  top: '5px',
  width: '20px'
};
export var searchInputSkeletonCSS = function searchInputSkeletonCSS(theme) {
  return _objectSpread(_objectSpread({}, searchCommonCSS), skeletonCSS(theme));
};